import { render } from "./MemberBook.vue?vue&type=template&id=4bbcf29b&scoped=true"
import script from "./MemberBook.vue?vue&type=script&lang=js"
export * from "./MemberBook.vue?vue&type=script&lang=js"

import "./MemberBook.vue?vue&type=style&index=0&id=4bbcf29b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbcf29b"]])

export default __exports__